




import {Component, Prop, Vue} from "vue-property-decorator";
//@ts-ignore
import DiceMessage from "./DiceMessage.vue";
import ChatCommandMessage from "./ChatCommandMessage.vue";
//@ts-ignore
import DiceCommand from "../../services/commands/DiceCommand";
//@ts-ignore
import store from "../../store";
import {ChatMessages} from "../../../types/chat-messages";
import ChatMessagesTypes from "../../../enums/chat-messages-types/ChatMessagesTypes";
import PlayerActionMessage from "./Messages/PlayerActionMessage/PlayerActionMessage.vue";
import PlayerCommonMessage from "./Messages/CommonMessage/PlayerCommonMessage.vue";
import SystemMessage from "./Messages/SystemMessage/SystemMessage.vue";
import SectionMessage from "./Messages/SectionMessage/SectionMessage.vue";
import ImportantMessage from "./Messages/ImportantMessage/ImportantMessage.vue";
import InvisibleMessage from "./Messages/InvisibleMessage/InvisibleMessage.vue";
import TemplateMessage from "./Messages/TemplateMessage/TemplateMessage.vue";

const MESSAGE_STATUS_PUBLIC = 1;
const MESSAGE_STATUS_ANONYMOUS = 3;

const MESSAGE_TYPE_VOTE = 1;

@Component({
    components: {DiceMessage,
        PlayerCommonMessage,
        PlayerActionMessage,
        SystemMessage,
        SectionMessage,
        ImportantMessage,
        ChatCommandMessage,
        TemplateMessage,
        InvisibleMessage}
})

export default class ChatMessageWidget extends Vue {
    @Prop({required: true}) private readonly message!: ChatMessages.Message;
    private componentName: string = '';

    mounted(): void
    {
        this.getComponentName(this.message);
    }

    /**
     * ID игрока
     * @private
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Сообщение Действия пользователя
     * Игрок пошел в комнату, перезапустил игру, сел/встал с сита
     * @param message
     * @private
     */
    private isPlayerActionMessage(message: ChatMessages.Message): boolean
    {
        return message.data && message.data.type === ChatMessagesTypes.MESSAGE_TYPE_PLAYER_ACTION;
    }

    /**
     * Системное сообщение - сообщение с призывом к какому-либо действию, с информацию о происходящих событиях в игре средней важности
     * В авто играх используется для сообщений от системы с комментариями, как вспомогательные для заголовков
     * @param message
     * @private
     */
    private isSystemType(message: ChatMessages.Message): boolean
    {
        return message.data && message.data.type === ChatMessagesTypes.MESSAGE_TYPE_SYSTEM_MESSAGE;
    }

    /**
     * Заголовок
     * В заголовок помещается название Раунда
     * @param message
     * @private
     */
    private isSectionMessage(message: ChatMessages.Message): boolean
    {
        return message.data && message.data.type === ChatMessagesTypes.MESSAGE_TYPE_SECTION_MESSAGE;
    }

    /**
     * Заголовок 2 - важное системное сообщение
     * Кого убили ночью в мафии, Роль игроков в Детектив Клабе
     * В авто играх перед текстом можно загрузить иконку, которая подчеркнет событие
     * @param message
     * @private
     */
    private isImportantMessage(message: ChatMessages.Message): boolean
    {
        return message.data && message.data.type === ChatMessagesTypes.MESSAGE_TYPE_IMPORTANT_MESSAGE;
    }

    /**
     * Сообщения от игроков
     * Дефолт сообщения игроков на ситах
     * Сообщения гостей. Подписан автор. Гость 1: Гость 2: итп
     * @param message
     * @private
     */
    private isCommonMessage(message: ChatMessages.Message): boolean
    {
        return !message.data && !message.command && !message.isTemplate;
    }

    /**
     * Вывод html-шаблона с сервера в чат
     * @param message
     * @private
     */
    private isTemplateMessage(message: ChatMessages.Message): boolean
    {
        return !message.data && !message.command && message.isTemplate;
    }

    /**
     * Получить текущий компонент
     * @param message
     * @private
     */
    private getComponentName(message: ChatMessages.Message): void
    {
        if (message.data && message.data.type === ChatMessagesTypes.MESSAGE_TYPE_VOTE) {
            return;
        }

        if (message.data && this.isSystemType(message)) {
            this.componentName = 'SystemMessage';
            return;
        }
        if (message.data && this.isPlayerActionMessage(message)) {
            this.componentName = 'PlayerActionMessage';
            return;
        }
        if (message.data && this.isSectionMessage(message)) {
            this.componentName = 'SectionMessage';
            return;
        }
        if (this.isImportantMessage(message)) {
            this.componentName = 'ImportantMessage';
            return;
        }
        if (message.command && this.getMessageCommandType(message.command) === 'dice') {
            this.componentName = 'DiceMessage';
            return;
        }
        if (!this.isMessageVisible(message)) {
            this.componentName = 'InvisibleMessage';
            return;
        }
        if (this.isCommonMessage(message)) {
            this.componentName = 'PlayerCommonMessage';
            return;
        }
        if (this.isTemplateMessage(message)) {
            this.componentName = 'TemplateMessage';
            return;
        }

        if (message.command
            && this.getMessageCommandType(message.command) !== 'dice'
            && this.getMessageCommandType(message.command) !== 't'
            && message.command !== '/voteres') {
            this.componentName = 'ChatCommandMessage';
            return;
        }
    }

    /**
     * Тип команды
     * @param command
     */
    private getMessageCommandType(command: any): string|null
    {

        if (DiceCommand.isValidCommand(command)) {
            return 'dice';
        }

        if (command.match(/^\/((t)(\s+)?)(((\s+)?(-)?(\s+)?((\d+)(:\d+)?)(\s+)?)?)+$/ui)) {
            return 't';
        }

        return null;
    }

    /**
     * Собощение видно текущему игроку
     */
    private isMessageVisible(message: ChatMessages.Message): boolean
    {
        if (!message) {
            return false;
        }
        if (message.playerId === this.playerId || message.status === MESSAGE_STATUS_ANONYMOUS) {
            return true;
        }

        return message.status === MESSAGE_STATUS_PUBLIC || message.visibleFor.indexOf(this.playerId) !== -1;
    }

    /**
     * Свернуть/развернуть секцию чата
     * @private
     */
    private toggleSectionVisibility(id: number): void
    {
        if (this.message.parentId) {
            this.$emit('toggle-section-visibility', id);
        }
    }

}
